// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56ae102e","239":"c21a90fd","453":"1d0be190","455":"7b9ebbb6","762":"23585fa0"}[chunkId] + ".chunk.js";
};